/** Arabic content of the chauffeur home (translation of HUB_FR / HUB_EN). */
import type { ChauffeurHubData } from "./hubDict";

export const HUB_AR: ChauffeurHubData = {
  hero: {
    eyebrow: "سائق خاص في كان",
    title: "سائق خاص وسيارة VTC في كان",
    subtitle:
      "تنقّلات راقية على الريفييرا الفرنسية: عمليات نقل، فعاليات، أعمال.",
    ctaPrimary: { href: "/reservation", label: "احجز" },
    ctaSecondary: { href: "/contact", label: "اطلب عرض سعر" },
    trustLine: "تأكيد فوري • دفع آمن • رد في أقل من دقيقة",
    chips: [
      "استقبال في المطار/الفندق",
      "تنسيق الفعاليات",
      "مرافقة بشرية مخصَّصة",
    ],
    bookingTitle: "احجز في 3 خطوات",
    steps: [
      "اختر تاريخ ووقت الاستلام",
      "حدِّد المسار أو الحاجة (نقل، خدمة تحت الطلب)",
      "تأكيد فوري",
    ],
    bookingCta: "احجز الآن",
    bookingNote: "لا حاجة إلى الدفع للبدء",
  },
  services: {
    eyebrow: "خدمات السائق الخاص",
    heading: "خدمات سائق راقية",
    intro:
      "خدمات راقية مصمَّمة وفق احتياجاتكم في كان وعلى كامل الريفييرا الفرنسية، مع الالتزام بالمواعيد والراحة والتكتّم.",
    mostRequested: "الخدمة الأكثر طلباً",
    priorityBadge: "أولوية للالتزام بالمواعيد والتنسيق",
    points: ["رد سريع", "استقبال راقٍ", "خدمة على مدار الساعة"],
    items: [
      {
        title: "النقل من المطارات",
        text: "وصول/مغادرة مُحسَّنان مع تتبّع الرحلات وتنسيق دقيق للمواعيد.",
        icon: "ph:airplane-tilt",
      },
      {
        title: "الخدمة تحت الطلب",
        text: "سائق خاص بالساعة أو نصف اليوم أو اليوم الكامل بما يناسب جدولكم.",
        icon: "ph:clock",
      },
      {
        title: "الفعاليات",
        text: "ترتيبات لكبار الشخصيات، خدمات نقل وإدارة التدفّق في كان وموناكو ونيس.",
        icon: "ph:calendar-check",
      },
      {
        title: "الأعمال",
        text: "جولات ترويجية واجتماعات عمل وتنقّلات للشركات بكل تكتّم.",
        icon: "ph:briefcase",
      },
      {
        title: "حفلات الزفاف",
        text: "تنظيم دقيق لمسار المراسم/الاستقبال مع خدمة راقية للضيوف.",
        icon: "ph:heart",
      },
      {
        title: "الرحلات",
        text: "مسارات خلابة وبرامج خاصة على الريفييرا الفرنسية والإيطالية.",
        icon: "ph:mountains",
      },
    ],
  },
  indicators: {
    heading: "مؤشرات الخدمة ووعد KS Rent Services",
    items: [
      {
        label: "التأكيد",
        value: "سريع",
        text: "رد ذو أولوية على الطلبات المؤهَّلة",
      },
      {
        label: "التوفّر",
        value: "7 أيام في الأسبوع",
        text: "استلام مُسبَق الترتيب وساعات ممتدة",
      },
      {
        label: "نطاق التغطية",
        value: "كان - موناكو - نيس",
        text: "امتدادات نحو الريفييرا الإيطالية عند الطلب",
      },
      {
        label: "التموضع",
        value: "فخامة بتكتّم",
        text: "خدمة رصينة وسلسة ودقيقة المواعيد",
      },
    ],
  },
  motion: {
    eyebrow: "التزام تشغيلي",
    heading: "منهج خدمتنا على الريفييرا الفرنسية",
    text: "في KS Rent Services، تُؤطَّر كل مهمة بنقطة تواصل واحدة، ومتابعة واضحة للمواعيد، وتنفيذ ميداني موثوق من كان إلى موناكو ونيس وصوفيا.",
    badge: "خدمة سائق خاص راقية",
    signatureText:
      "سائق خاص في كان وعلى الريفييرا الفرنسية: عمليات نقل، أعمال، فعاليات وخدمة تحت الطلب بمستوى خدمة ثابت.",
    leftAlt: "تجربة راكب راقية",
    rightAlt: "النقل من المطارات ومهابط الطائرات",
  },
  locations: {
    eyebrow: "التغطية الجغرافية للسائق",
    heading: "المناطق المشمولة والمسارات المفضَّلة",
    introPrefix:
      "خدمة سائق خاص مقرّها كان، تغطّي كامل الريفييرا الفرنسية حتى موناكو. ",
    srPrefix: "المناطق المشمولة: ",
    corridorsTitle: "المسارات ذات الأولوية",
    corridorNote: "انطلاق مرن - تأكيد منظَّم",
    corridorPrefix: "كان -> ",
    items: [
      {
        name: "كان",
        description: "القاعدة التشغيلية وانتشار سريع لأي طلب محلي",
      },
      {
        name: "نيس",
        description: "وسط المدينة والمطار وأحياء الأعمال",
      },
      {
        name: "أنتيب",
        description: "المدينة القديمة وجوان لي بان والحي المخصَّص للفعاليات",
      },
      {
        name: "موناكو",
        description: "الإمارة والفنادق والمواقع المؤسسية",
      },
      {
        name: "ماندوليو",
        description: "السكن والمرسى وروابط اجتماعات العمل",
      },
      { name: "غراس", description: "رحلات الأعمال والتنقّلات الخاصة" },
      {
        name: "سان تروبيه",
        description: "عمليات نقل راقية موسمية وفي عطلات نهاية الأسبوع",
      },
      {
        name: "مونتون",
        description: "تنقّلات بعيدة المدى في شرق الريفييرا الفرنسية",
      },
      {
        name: "ميلانو",
        description: "عند الطلب للاحتياجات التنفيذية والفعاليات",
      },
      {
        name: "الريفييرا الإيطالية",
        description: "امتداد منسجم لمساركم الرئيسي",
      },
    ],
  },
  process: {
    heading: "مسار خدمة السائق في 4 خطوات واضحة",
    intro:
      "منهج بسيط لتجنّب التردّد: أنتم تحدِّدون الحاجة، ونحن نؤطِّر الخدمة، نؤكِّد، ثم ننفِّذ.",
    stepWord: "الخطوة",
    steps: [
      "تحديد الحاجة: المسار، التوقيت، الأولويات، عدد الركاب.",
      "اقتراح الخدمة: الصيغة، المدّة، الخيارات والقيود الميدانية.",
      "تأكيد كتابي: نقطة اللقاء، تذكير لوجستي وتعليمات.",
      "التنفيذ: متابعة نشطة حتى الوجهة النهائية.",
    ],
    leftAlt: "تنسيق سائق خاص راقٍ",
    rightAlt: "استقبال الركاب ومتابعة المواعيد",
  },
  seoContent: {
    eyebrow: "معلومات مفيدة عن خدمة السائق",
    heading: "سائق خاص في كان: محتوى مفيد للمقارنة واتخاذ القرار",
    paragraphs: [
      "تلبّي خدمة السائق الخاص لدينا في كان احتياجات الأعمال والفعاليات والتنقّلات الخاصة بمستوى خدمة ثابت: التزام بالمواعيد، سلاسة، تكتّم.",
      "تحصلون على حل واضح قبل الانطلاق: صيغة الخدمة، الإطار الزمني، الخيارات المفيدة ومستوى المرافقة المناسب للسياق.",
      "الهدف ليس نقلكم فحسب، بل حماية جدولكم وصورتكم وراحة الركاب في كل مرحلة من مراحل الرحلة.",
    ],
    bullets: [
      "استلام 7 أيام في الأسبوع مع تأكيد منظَّم",
      "سائقون ذوو خبرة، وأسلوب راقٍ ومتكتّم",
      "مسارات قابلة للتخصيص دون تعقيد الحجز",
      "تسعير واضح وتواصل استباقي",
    ],
    metrics: [
      { k: "متوسط الرد", v: "< 15 دقيقة" },
      { k: "التوفّر", v: "7 أيام في الأسبوع" },
      { k: "نطاق التغطية", v: "كان - موناكو - نيس" },
    ],
    whyTitle: "لماذا تختاروننا",
    whyItems: [
      "سائقون ذوو خبرة ومتكتّمون",
      "مركبات راقية تخضع للصيانة",
      "حجز بسيط وتأكيد سريع",
      "خدمة على مدار الساعة انطلاقاً من كان",
    ],
  },
  atouts: {
    eyebrow: "نقاط قوة شاملة",
    heading: "نقاط القوة المستمدّة من خدمات السائق لدينا",
    intro:
      "نقاط قوة ملموسة مُعتمَدة عبر صفحاتنا الخاصة بالمطار والفعاليات والشركات وكان والريفييرا الفرنسية والخدمات.",
    items: [
      {
        title: "تتبّع الرحلات",
        text: "تعديل لحظي عند الوصول الحسّاس.",
      },
      {
        title: "مدير المشروع",
        text: "تنسيق مخصَّص لعمليات فعالياتكم.",
      },
      {
        title: "اتفاقية مستوى الخدمة والموثوقية",
        text: "إطار خدمة واضح لاحتياجات الشركات.",
      },
      {
        title: "الوصول إلى الفعاليات",
        text: "توجيه سلس للمؤتمرات والمعارض والمهرجانات.",
      },
      {
        title: "المعرفة المحلية",
        text: "مسارات مُكيَّفة عبر كامل الريفييرا الفرنسية.",
      },
      {
        title: "الالتزام بالمواعيد على مدار الساعة",
        text: "تنفيذ ثابت للطلبات ذات الأولوية.",
      },
    ],
  },
  faq: {
    eyebrow: "الأسئلة الشائعة",
    heading: "الأسئلة الشائعة حول السائق الخاص",
    items: [
      {
        q: "متى يكون الوقت المناسب لحجز سائق خاص؟",
        a: "في أقرب وقت ممكن خلال فترات الذروة. وللطلبات العاجلة، أرسلوا توقيتكم الدقيق وسنؤكِّد الجدوى بسرعة.",
      },
      {
        q: "هل تناسب الخدمة تحت الطلب أيام العمل؟",
        a: "نعم. إنها الصيغة الأكثر مرونة لربط الاجتماعات، ومسار متغيّر، وتعديلات خلال اليوم.",
      },
      {
        q: "هل يمكنكم إدارة فعالية بعدة نقاط استلام؟",
        a: "نعم، يمكننا تنظيم خطة استلام متعدّدة النقاط مع تنسيق تشغيلي للحفاظ على تدفّق واضح للركاب.",
      },
      {
        q: "ما الفرق بين سيارة الأجرة العادية وخدمة السائق هذه؟",
        a: "تُبنى خدمة السائق حول رحلتكم الشاملة، بمستوى أعلى من التخصيص والمتابعة.",
      },
    ],
    asideEyebrow: "رد سريع",
    asideTitle: "بحاجة إلى تأكيد سريع قبل الحجز؟",
    asideText:
      "يمكن لفريقنا تأكيد الجدوى ونطاق الخدمة وإطار الاستلام لطلباتكم ذات الأولوية.",
    asideBullets: [
      "مرافقة 7 أيام في الأسبوع",
      "استقبال بالفرنسية / الإنجليزية",
      "تنسيق الفعاليات والمطار",
    ],
  },
  fleet: {
    eyebrow: "أسطولنا",
    heading: "صفحة لكل مركبة في أسطول سائقينا",
    intro:
      "اختاروا المركبة المناسبة لرحلتكم: سيدان أعمال، سيدان هيبة، فان 7 مقاعد، SUV فاخرة، ميني‑باص VIP أو مركبة مصفّحة.",
    links: [
      {
        label: "سيدان مع سائق (الفئة E)",
        href: "/ar/chauffeur/berline-avec-chauffeur",
      },
      {
        label: "مرسيدس الفئة S مع سائق",
        href: "/ar/chauffeur/classe-s-avec-chauffeur",
      },
      {
        label: "فان مع سائق — 7 مقاعد",
        href: "/ar/chauffeur/van-avec-chauffeur",
      },
      {
        label: "رينج روفر مع سائق — SUV",
        href: "/ar/chauffeur/suv-avec-chauffeur",
      },
      {
        label: "ميني‑باص VIP — حتى 16 مقعداً",
        href: "/ar/chauffeur/minibus-vip",
      },
      {
        label: "سائق أمني ومركبة مصفّحة",
        href: "/ar/chauffeur/chauffeur-securite",
      },
    ],
  },
  complementary: {
    heading: "خدمات تكميلية",
    intro:
      "اطّلعوا على الصفحات المفيدة للمقارنة السريعة بين خدمات السائق والرحلات الخاصة وتأجير المركبات.",
    links: [
      {
        label: "رحلات خاصة على الريفييرا الفرنسية",
        href: "/excursions",
      },
      { label: "تأجير مركبات راقية", href: "/location/vehicules" },
      {
        label: "سائق للنقل من المطار",
        href: "/ar/chauffeur/transferts",
      },
      {
        label: "سيارة زفاف في كان",
        href: "/ar/chauffeur/voiture-mariage-cannes",
      },
      { label: "احجز رحلتك عبر الإنترنت", href: "/reservation" },
    ],
  },
  seo: {
    title:
      "سائق خاص في كان وسيارة VTC على الريفييرا الفرنسية | KS Rent Services",
    description:
      "سائق خاص وسيارة VTC في كان: نقل من المطارات، فعاليات، أعمال وخدمة تحت الطلب على الريفييرا الفرنسية. حجز بسيط، خدمة 7 أيام في الأسبوع.",
    canonical: "/ar/chauffeur",
  },
};
